import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { reactHookForm, designSystem } from '@yola/ws-ui';
import ModalWithPanels from 'src/js/modules/common/components/modal-with-panels';
import { MAX_SLUG_LENGTH } from '../constants/slug';
import createBindingSlugValidator from '../validators/create-binding-slug-validator';

const { useForm } = reactHookForm;
const { ControlGroup, InputGroupField } = designSystem;

const MODAL_WIDTH = 360;
const MODAL_HEIGHT = 'auto';
const FIELD_NAME = 'slug';
const defaultBindings = [];

function ConnectToCmsDialog({ onSubmit, onCancel, existingSlug = '', bindings = defaultBindings }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      [FIELD_NAME]: existingSlug || '',
    },
  });

  const handleDialogSubmit = (values) => {
    onSubmit(values[FIELD_NAME].trim());
  };

  return (
    <ModalWithPanels
      width={MODAL_WIDTH}
      height={MODAL_HEIGHT}
      captions={{
        title: i18next.t('Connect to CMS'),
        submitButton: i18next.t('Submit'),
        cancelButton: i18next.t('Cancel'),
      }}
      overlay="visible"
      draggable={false}
      centered
      onSubmit={handleSubmit(handleDialogSubmit)}
      onCancel={onCancel}
      onOverlayClick={onCancel}
      onPressEsc={onCancel}
    >
      <ControlGroup title={i18next.t('Variable name')} required>
        <InputGroupField
          control={control}
          name={FIELD_NAME}
          maxLength={MAX_SLUG_LENGTH}
          rules={{
            validate: createBindingSlugValidator({ bindings, existingSlug }),
          }}
        />
      </ControlGroup>
    </ModalWithPanels>
  );
}

ConnectToCmsDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  existingSlug: PropTypes.string,
  bindings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ),
};

export default ConnectToCmsDialog;
